import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
    name: 'yesNo'
})
export class YesNoPipe implements PipeTransform {
    transform(value: any) {
        if (value != null) {
          return "Yes"
        } else {
          return "No";
        }
    }

}
